export const PROGRAM_SECTION_ARTICLE_TREE_CONTENT_TYPE =
  'programSectionArticleTree'
export const LOADING_TEXT = 'Loading...'
